<template>
  <div v-loading="loading" class="base_scroll_page">
    <div class="b_scroller">
      <div class="base_inquire">
        <div class="b_item">
          <span class="b_label">开始时间：</span>
          <el-date-picker
            v-model="generaler_startTime"
            :editable="false"
            placeholder="开始时间"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="handleSearchStartTimeClick"
          ></el-date-picker>
        </div>

        <div class="b_item">
          <span class="b_label">结束时间：</span>
          <el-date-picker
            v-model="generaler_endTime"
            :editable="false"
            placeholder="结束时间"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="handleSearchEndTimeClick"
          ></el-date-picker>
        </div>
        <el-button type="primary" @click="handleSearchClick">查询</el-button>
      </div>

      <!-- 表格 -->
      <div class="base_table" style="margin-top: 20px">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="code" label="账号"></el-table-column>
          <el-table-column prop="name" label="姓名"></el-table-column>
          <el-table-column prop="bonusDays" label="赠送天数"></el-table-column>
          <el-table-column prop="bonusCount" label="赠送次数"></el-table-column>
          <el-table-column label="操作" width="180">
            <template slot-scope="scope">
              <el-button
                v-if="authInfo.ucategory == 1"
                type="primary"
                size="small"
                @click="handleRechargeClick(scope.row)"
                >充值</el-button
              >
              <el-button
                type="primary"
                size="small"
                @click="handleRechargeRecordClick(scope.row)"
                >充值记录</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 表格 end -->

      <!-- 页码 -->
      <div class="clear_both" style="margin-top: 20px">
        <div class="base_pager" style="float: right">
          <el-pagination
            layout="total, prev, pager, next, jumper"
            next-text="下一页"
            :total="total"
            :current-page="currentPage"
            @current-change="handlePageChange"
          ></el-pagination>
        </div>
      </div>
      <!-- 页码 end -->
    </div>

    <!-- 充值弹出框 -->
    <recharge
      v-model="rechargeGeneraler_popup_display"
      :id="rechargeGeneraler_id"
      :name="rechargeGeneraler_name"
      :code="rechargeGeneraler_code"
      :products="userProducts"
      :objectType="0"
      :powerInfo="true"
      @success="handleRechargeSuccess"
      :gift="true"
    ></recharge>
    <!-- 充值弹出框 end -->

    <!-- 充值记录弹出框 -->
    <recharge-record
      v-model="rechargeRecord_popup_display"
      :id="rechargeRecord_id"
      :code="rechargeRecord_code"
      type="0"
    ></recharge-record>
    <!-- 充值记录弹出框 end -->
  </div>
</template>

<script>
/* 
	/training/product-patient-relative/yesterday-recharge-bonus

	 */
import Api from "../../../../api/index.js";
import { mapState } from "vuex";
import Recharge from "./components/recharge.vue";
import RechargeRecord from "./components/recharge_record.vue";

export default {
  name: "gift",
  data() {
    return {
      loading: false,
      tableData: [],
      currentPage: 1,
      total: 0,
      generaler_startTime: "",
      generaler_endTime: "",
      addComplete: false,
      userProducts: [],
      rechargeGeneraler_popup_display: false,
      rechargeGeneraler_id: "",
      rechargeGeneraler_name: "",
      rechargeGeneraler_code: "",
      rechargeRecord_popup_display: false,
      rechargeRecord_id: "",
      rechargeRecord_code: "",
    };
  },
  computed: {
    ...mapState(["authInfo"]),
  },
  mounted() {
    console.log(Api);
    // 获取用户
    this.getUserGiftList();
  },
  methods: {
    handleSearchStartTimeClick() {
      this.compareSearchTime();
    },
    handleSearchEndTimeClick() {
      this.compareSearchTime();
    },
    handleSearchClick() {
      this.currentPage = 1;
      this.getUserGiftList();
    },
    handlePageChange(page) {
      if (this.currentPage != page) {
        this.currentPage = page;
        this.getUserGiftList();
      }
    },
    compareSearchTime() {
      if (this.generaler_startTime && this.generaler_endTime) {
        var startTime = new Date(this.generaler_startTime).getTime(),
          endTime = new Date(this.generaler_endTime).getTime();
        if (endTime < startTime) {
          this.generaler_endTime = "";
          this.$message.warning("结束时间不能小于开始时间");
        }
      }
    },
    getUserGiftList() {
      const that = this;
      that.loading = true;
      const _category = this.authInfo.ucategory;
      var _requestData = {
        tempCategory: _category,
        startDate: that.generaler_startTime,
        endDate: that.generaler_endTime,
        limit: 10,
        pageNum: that.currentPage,
      };
      Api.giftUser(_requestData).then(
        (res) => {
          that.loading = false;
          if (res.data.success) {
            that.total = res.data.data.total || 0;
            that.tableData = [];
            var records = res.data.data.records || [];
            for (var i = 0; i < records.length; i++) {
              that.tableData.push({
                userId: records[i].userId || "",
                name: records[i].userName || "",
                code: records[i].userCode || "",
                bonusDays: records[i].bonusDays || 0,
                bonusCount: records[i].bonusCount || 0,
                enterpriseId: records[i].enterpriseId || 0,
              });
            }
          } else {
            that.$message.error(res.data.message);
          }
        },
        (e) => {
          that.loading = false;
          that.$message.error(e.message);
        },
      );
    },
    handleRechargeClick(data) {
      console.log(data);
      const that = this;
      if (!data.userId) {
        this.$message.warning("该用户不属于任何机构，暂时无法充值！！！");
        return false;
      }
      that.addComplete = false;
      that.rechargeGeneraler_id = data.userId;
      that.rechargeGeneraler_name = data.name;
      that.rechargeGeneraler_code = data.code;
      that.loading = true;
      var requestData = {
          inputPhoneNum: data.code,
          uenterpriseId: data.enterpriseId,
        },
        result = [];
      Api.getUserProducts(requestData).then(
        (res) => {
          that.loading = false;
          if (res.data.success) {
            for (var i = 0; i < res.data.data.length; i++) {
              result.push({
                id: res.data.data[i].productId,
                name: res.data.data[i].productName,
              });
            }
            if (result.length) {
              that.userProducts = result;
              that.rechargeGeneraler_popup_display = true;
            } else {
              that.$message({
                message: "该用户暂未开通产品，无法充值",
                type: "warning",
              });
            }
          } else {
            that.$message.error(res.data.message);
          }
        },
        (e) => {
          that.loading = false;
          that.$message.error(e.message);
        },
      );
    },
    handleRechargeRecordClick(data) {
      this.rechargeRecord_id = data.userId;
      this.rechargeRecord_code = data.code;
      this.rechargeRecord_popup_display = true;
    },
    handleRechargeSuccess(msg) {
      this.$message({
        message: msg,
        type: "success",
      });
      this.rechargeGeneraler_popup_display = false;
    },
  },
  components: {
    Recharge,
    RechargeRecord,
  },
};
</script>

<style></style>
